import React, { Fragment } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { colorsNew } from 'root/src/client/web/commonStyles'
import Link from 'root/src/client/web/base/Link'
import classNames from 'classnames'

const style = {
	text: {
		fontWeight: 'bold',
		lineHeight: 1.5,
	},
	link: {
		color: colorsNew.link,
		textDecoration: 'none',
	},
}

const StringWithLinks = ({
	text, linkLabel,
	href, routeId, classes, newLineAfter, linkStyles,
}) => {
	const splits = text.split(linkLabel)
	const renderLinkMod = () => (routeId
		? <Link routeId={routeId}>{linkLabel}</Link>
		: (
			<a
				href={href}
				className={classNames(classes.link, classes.text)}
				style={linkStyles}
				target="_blank"
				rel="noopener noreferrer"
			>
				{linkLabel}
			</a>
		))
	return (
		<Fragment>
			{splits[0]}
			{renderLinkMod()}
			{splits[1]}
			{newLineAfter && <br />}
		</Fragment>
	)
}

export default withStyles(style, { name: 'MuiStringWithLink' })(StringWithLinks)
